<script setup lang="ts">
import type { LocationCollectionItem } from '@nuxt/content'

const props = defineProps<{ location: LocationCollectionItem }>()

const firstAnimal = props.location.animals?.at(0) ?? 'uncategorized'

const src = `/images/animals/markers/${firstAnimal}.svg`

const { activeLocation } = useMapState()!

function setActive() {
  activeLocation.value = props.location
}
</script>

<template>
  <img
    :src="src"
    alt="Marker"
    width="32"
    height="48"
    class="opacity-80 hover:opacity-100 cursor-pointer"
    @click="setActive"
  >
</template>
